import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/api/client';
import type { MailHealthResponse } from '@/api/types';
import { useProjectContext } from '@/project/ProjectContext';

export function useMailHealth() {
  const { selectedProjectId } = useProjectContext();
  const qs = selectedProjectId ? `?project_id=${encodeURIComponent(selectedProjectId)}` : '';

  return useQuery({
    queryKey: ['dashboard', 'mail-health', selectedProjectId ?? 'all'],
    queryFn: () => apiFetch<MailHealthResponse>(`/api/dashboard/mail-health${qs}`),
  });
}
